import React, { useState, useEffect } from "react";
import Icon from '../../../components/AppIcon';

const API_URL = import.meta.env.VITE_API_URL;

const WelcomeHeader = () => {
  const [currentDate, setCurrentDate] = useState("");

useEffect(() => {
  fetch(`${API_URL}/target_time`, {
    credentials: "include"
  })
    .then(async res => {
      const raw = await res.text();
      console.log("RAW RESPONSE:", raw);

      const data = JSON.parse(raw);
      const date = new Date(data.target_time);

      const formatted = date.toLocaleDateString("fa-IR-u-ca-persian", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });

      setCurrentDate(formatted);
    })
    .catch(err => console.error(err));
}, []);

  return (
    <div className="bg-gradient-to-r from-blue-600 to-emerald-600 text-white p-6 shadow-soft">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
              <Icon name="DollarSign" size={24} color="white" strokeWidth={2} />
            </div>
            <div>
              <h1 className="font-bold">دستیار مالی ارزیابی</h1>
              <p className="text-blue-100 text-sm">{currentDate}</p>
            </div>
          </div>

          <div className="hidden md:flex items-center space-x-6">
            <div className="text-center">
              <div className="flex items-center space-x-1">
                <Icon name="Shield" size={16} color="white" strokeWidth={2} />
                <span className="text-sm font-medium">امنیت</span>
              </div>
              <p className="text-xs text-blue-100">رمزنگاری در سطح بانک‌ها</p>
            </div>
            <div className="text-center">
              <div className="flex items-center space-x-1">
                <Icon name="Clock" size={16} color="white" strokeWidth={2} />
                <span className="text-sm font-medium">۲۴/۷</span>
              </div>
              <p className="text-xs text-blue-100">همیشه در دسترس</p>
            </div>
            <div className="text-center">
              <div className="flex items-center space-x-1">
                <Icon name="Brain" size={16} color="white" strokeWidth={2} />
                <span className="text-sm font-medium">هوش مصنوعی</span>
              </div>
              <p className="text-xs text-blue-100">بینش‌های هوشمند</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeHeader;
